import { Navigate } from 'react-router-dom';
import { isTokenExpired } from '@/lib/jwt';
import { ROUTES } from '@/routes/paths';
import { selectToken, useAuthStore } from '@/stores/auth-store';

/**
 * `/` no muestra nada: decide adónde ir según haya sesión utilizable o no.
 * La comprobación es solo del `exp` del JWT (la firma la valida el backend); si el token
 * está vencido se manda a `/login` y `RequireAuth` remata el trabajo si hiciera falta.
 */
export function RootRedirect() {
  const token = useAuthStore(selectToken);
  const target = token && !isTokenExpired(token) ? ROUTES.dashboard : ROUTES.login;

  return <Navigate to={target} replace />;
}
